// THIS FILE IS AUTO-GENERATED. DO NOT MODIFY IT.
// Please edit ./day.theme.ts instead, then run `npm run theme:build`
import { css } from '@linaria/core'

export default css`
  --gray00: #fefefe;
  --gray00a: rgba(0, 0, 0, 0.004);
  --gray02: #f5f6f6;
  --gray02a: rgba(0, 26, 26, 0.039);
  --gray03: #eaecec;
  --gray03a: rgba(0, 24, 24, 0.082);
  --gray05: #dcdede;
  --gray05a: rgba(0, 15, 15, 0.137);
  --gray10: #cacdcd;
  --gray10a: rgba(0, 14, 14, 0.208);
  --gray20: #b5b8b9;
  --gray20a: rgba(0, 10, 14, 0.29);
  --gray30: #9ea1a3;
  --gray30a: rgba(0, 8, 13, 0.38);
  --gray40: #888c8e;
  --gray40a: rgba(0, 9, 13, 0.467);
  --gray50: #75797b;
  --gray50a: rgba(0, 7, 11, 0.541);
  --gray60: #64686a;
  --gray60a: rgba(0, 7, 10, 0.608);
  --gray70: #535658;
  --gray70a: rgba(0, 4, 7, 0.675);
  --gray80: #434547;
  --gray80a: rgba(0, 3, 5, 0.737);
  --gray90: #333435;
  --gray90a: rgba(0, 1, 3, 0.8);
  --gray100: #202121;
  --gray100a: rgba(0, 1, 1, 0.875);
  --blue02: #edf7fb;
  --blue02a: rgba(0, 142, 198, 0.071);
  --blue03: #d8f0f8;
  --blue03a: rgba(0, 157, 209, 0.153);
  --blue05: #b7e6f4;
  --blue05a: rgba(0, 166, 216, 0.282);
  --blue10: #8ed7ea;
  --blue10a: rgba(0, 165, 208, 0.443);
  --blue20: #5bc5de;
  --blue20a: rgba(0, 165, 204, 0.643);
  --blue30: #39aecb;
  --blue30a: rgba(0, 151, 188, 0.776);
  --blue40: #2097b7;
  --blue40a: rgba(0, 136, 173, 0.875);
  --blue50: #0383a4;
  --blue50a: rgba(0, 130, 163, 0.988);
  --blue60: #057091;
  --blue60a: rgba(0, 109, 143, 0.98);
  --blue70: #005c82;
  --blue70a: rgba(0, 92, 130, 1);
  --blue80: #004873;
  --blue80a: rgba(0, 72, 115, 1);
  --blue90: #00365d;
  --blue90a: rgba(0, 54, 93, 1);
  --green02: #f5f6e8;
  --green02a: rgba(144, 155, 0, 0.09);
  --green03: #ebf1bd;
  --green03a: rgba(178, 201, 0, 0.259);
  --green05: #dbe773;
  --green05a: rgba(189, 211, 0, 0.549);
  --green10: #c5d72c;
  --green10a: rgba(185, 207, 0, 0.827);
  --green20: #a8c310;
  --green20a: rgba(162, 191, 0, 0.937);
  --green30: #88ad21;
  --green30a: rgba(118, 161, 0, 0.871);
  --green40: #6a992e;
  --green40a: rgba(73, 131, 0, 0.82);
  --green50: #4f8636;
  --green50a: rgba(32, 101, 0, 0.788);
  --green60: #397339;
  --green60a: rgba(0, 75, 0, 0.776);
  --green70: #276136;
  --green70a: rgba(0, 68, 18, 0.847);
  --green80: #1b4e2f;
  --green80a: rgba(0, 57, 22, 0.894);
  --green90: #163a26;
  --green90a: rgba(0, 39, 18, 0.914);
  --yellow02: #faf7db;
  --yellow02a: rgba(220, 198, 0, 0.141);
  --yellow03: #f9eda1;
  --yellow03a: rgba(239, 206, 0, 0.369);
  --yellow05: #fddd47;
  --yellow05a: rgba(252, 208, 0, 0.722);
  --yellow10: #ffc400;
  --yellow10a: rgba(255, 196, 0, 1);
  --yellow20: #f9a519;
  --yellow20a: rgba(248, 155, 0, 0.902);
  --yellow30: #f87f09;
  --yellow30a: rgba(248, 122, 0, 0.965);
  --yellow40: #ea6108;
  --yellow40a: rgba(233, 92, 0, 0.969);
  --yellow50: #ce5012;
  --yellow50a: rgba(202, 67, 0, 0.929);
  --yellow60: #af4619;
  --yellow60a: rgba(166, 50, 0, 0.902);
  --yellow70: #8f3d1c;
  --yellow70a: rgba(129, 37, 0, 0.89);
  --yellow80: #6f331c;
  --yellow80a: rgba(93, 26, 0, 0.89);
  --yellow90: #512919;
  --yellow90a: rgba(62, 18, 0, 0.902);
  --red02: #fcf4f5;
  --red02a: rgba(185, 0, 23, 0.043);
  --red03: #fce6e9;
  --red03a: rgba(224, 0, 31, 0.098);
  --red05: #fed3da;
  --red05a: rgba(249, 0, 41, 0.173);
  --red10: #ffbac5;
  --red10a: rgba(255, 0, 41, 0.271);
  --red20: #fb9cae;
  --red20a: rgba(245, 0, 46, 0.388);
  --red30: #f67896;
  --red30a: rgba(238, 0, 57, 0.529);
  --red40: #ed5481;
  --red40a: rgba(228, 0, 67, 0.671);
  --red50: #df306e;
  --red50a: rgba(216, 0, 76, 0.812);
  --red60: #ca0d5e;
  --red60a: rgba(199, 0, 85, 0.949);
  --red70: #ab024e;
  --red70a: rgba(170, 0, 77, 0.992);
  --red80: #86123f;
  --red80a: rgba(125, 0, 48, 0.929);
  --red90: #621730;
  --red90a: rgba(82, 0, 27, 0.91);
  --purple02: #f8f5fc;
  --purple02a: rgba(77, 0, 179, 0.039);
  --purple03: #f1e8fb;
  --purple03a: rgba(100, 0, 211, 0.09);
  --purple05: #e9d7fc;
  --purple05a: rgba(115, 0, 236, 0.157);
  --purple10: #e0c0fe;
  --purple10a: rgba(130, 0, 251, 0.247);
  --purple20: #d9a0ff;
  --purple20a: rgba(153, 0, 255, 0.373);
  --purple30: #bf89f2;
  --purple30a: rgba(117, 0, 227, 0.463);
  --purple40: #a678d0;
  --purple40a: rgba(87, 0, 166, 0.529);
  --purple50: #8e69b0;
  --purple50a: rgba(63, 0, 121, 0.588);
  --purple60: #785b93;
  --purple60a: rgba(45, 0, 87, 0.643);
  --purple70: #624d76;
  --purple70a: rgba(30, 0, 59, 0.698);
  --purple80: #4e3e5c;
  --purple80a: rgba(21, 0, 40, 0.757);
  --purple90: #3a3043;
  --purple90a: rgba(12, 0, 23, 0.812);
  --danger02: #faf5f4;
  --danger02a: rgba(139, 23, 0, 0.043);
  --danger03: #f6e9e6;
  --danger03a: rgba(163, 31, 0, 0.098);
  --danger05: #f3d9d4;
  --danger05a: rgba(184, 30, 0, 0.169);
  --danger10: #f0c2ba;
  --danger10a: rgba(200, 30, 0, 0.271);
  --danger20: #eca69b;
  --danger20a: rgba(207, 28, 0, 0.392);
  --danger30: #e88576;
  --danger30a: rgba(212, 28, 0, 0.537);
  --danger40: #e26454;
  --danger40a: rgba(212, 24, 0, 0.671);
  --danger50: #d94233;
  --danger50a: rgba(208, 19, 0, 0.8);
  --danger60: #c52a25;
  --danger60a: rgba(187, 6, 0, 0.855);
  --danger70: #9e2c25;
  --danger70a: rgba(142, 8, 0, 0.855);
  --danger80: #7a2922;
  --danger80a: rgba(102, 8, 0, 0.867);
  --danger90: #59231d;
  --danger90a: rgba(68, 7, 0, 0.886);
  --elev-veil-color: transparent;
  --gradient-color-base: 100%;

  color-scheme: light;
  color: var(--gray100);
  &:not([transparent]) {
    background: var(--gray00);
  }
`
